export default __webpack_public_path__ + "media/src/assets/images/switcher-3bee37471cf3b2c6212f3033d417b1a2.svg";